/**
 * MarkerContent will compose a marker's description to be shown inside an infobox.
 * This plugin will only generate the content that appears inside an infobox and
 * append click events to the markers so an action is dispatched when clicked.
 * This plugin does not place markers on the map, and does not open any infowindow.
 * It simple formats the data that appears inside an infowindow. It does not call
 * any functions when markers are click either. It simply dispatches an action.
 */
(function () {
  var MarkerContent = function () {
    var self = this;

    var createMarkerDescription = function (row) {
      var description = "";
      var rowMarker = self.options.markersData.mapRS[row];
      var rowData = self.options.markersData.dataRS[row];
      var markersData = self.options.markersData;

      if (self.options.markersData.desc_col == -1 && rowData) {
        var selectedColumn = [
          "bg_distance",
          "bg_postal",
          "bg_lat",
          "bg_long",
          "bg_accuracy",
          markersData.columnNames[markersData.title_col],
          markersData.columnNames[markersData.descIMG_col],
          markersData.columnNames[markersData.descURL_col],
          markersData.columnNames[markersData.address_col],
          markersData.columnNames[markersData.city_col],
          markersData.columnNames[markersData.state_col],
          markersData.columnNames[markersData.zip_col],
          markersData.columnNames[markersData.lat_col],
          markersData.columnNames[markersData.long_col],
          markersData.columnNames[markersData.country_col],
        ];

        const lastIndex = self.options.markersData.columnNames.length - 1;
        self.options.markersData.columnNames
          .filter((columnName, index) => {
            // if we added a distance column, don't include it in marker content
            if (
              index === lastIndex &&
              columnName.toLowerCase() === "distance"
            ) {
              return false;
            }
            return true;
          })
          .forEach(function (columnName, index) {
            if (selectedColumn.indexOf(columnName) === -1) {
              if (
                columnName.toLowerCase() === "email" ||
                columnName.toLowerCase() === "e-mail"
              ) {
                // email set to NONE
                if (markersData.email_col < 0) {
                  // add email as a regular item "email: email@email.com"
                  description +=
                    "<div>" +
                    (self.options.markersData.field_cb_status
                      ? '<span class="l">' + columnName + ":</span>&nbsp;"
                      : "") +
                    rowData[index] +
                    "</div>";
                }
              } else {
                if (
                  rowData[index] &&
                  typeof rowData[index] === "string" &&
                  BatchGeo.toStr(rowData[index]).length
                ) {
                  description +=
                    "<div>" +
                    (self.options.markersData.field_cb_status
                      ? '<span class="l">' + columnName + ":</span>&nbsp;"
                      : "");
                  //Add <a> tag with href="tel: when viewing on a mobile device.
                  if (
                    columnName.search(/(t(e|é)l(e|é)(f|ph)on(e|o)?)|phone/i) >
                    -1
                  ) {
                    description +=
                      '<a href="tel:' +
                      rowData[index] +
                      '">' +
                      rowData[index] +
                      "</a>";
                  } else {
                    description += rowData[index];
                  }
                  description += "</div>";
                }
              }
            }
          });
      } else if (rowData && rowData[self.options.markersData.desc_col]) {
        description =
          "<div>" +
          BatchGeo.ifstr(rowData[self.options.markersData.desc_col]) +
          "</div>";
      }

      if (
        window.per.dist_cb_status &&
        rowMarker &&
        rowMarker.distance &&
        row !== 0
      ) {
        // display distance
        description =
          description +
          '<div><span class="l">' +
          self.options.distance_str +
          ":</span>&nbsp;" +
          BatchGeo.addCommas(rowMarker.distance) +
          (self.options.markersData.dist_sel ? "&nbsp;km" : "&nbsp;mi") +
          "</div>";
      }

      return description;
    };

    var createMarkerAddress = function (rowId) {
      var address;
      var rM = self.options.markersData.mapRS[rowId];
      if (!rM) return;
      // build display address
      address = rM.a && rM.a.length ? rM.a + "<br />" : rM.a;
      address = rM.c && rM.c.length ? address + rM.c : address;
      address =
        rM.s && rM.s.length && rM.c.length
          ? address + ", " + rM.s
          : address + rM.s.trim();
      address =
        ((rM.s && rM.s.length) || rM.c.length) && rM.z && rM.z.length
          ? address + " " + rM.z
          : address + " " + rM.z;
      address = rM.ct && rM.ct.length ? address.trim() + " " + rM.ct : address;

      return address;
    };

    var pointToZoom = function () {
      const lastMarker =
        BatchGeoStore.getState().MapsMarkersManager.lastOpenedMarker;
      if (!lastMarker) {
        return;
      }

      const map = window.batchGeoGoogleMapsManager.getMap();
      map.setCenter(lastMarker.getPosition());

      if (map.getZoom() < 12) {
        map.setZoom(12);
      } else {
        map.setZoom(map.getZoom() + 1);
      }
    };

    var bindClickToMarker = function (marker) {
      google.maps.event.addListener(marker, "click", function (e) {
        const { DrawingManager, MobileInfoWindow, MapsMarkersManager } =
          BatchGeoStore.getState();
        // check if were trying to select more than 1 marker, cause this
        // causes weirdness if the mouseup and drawing selection end
        if (!DrawingManager.currentlySelecting) {
          const lastOpenedMarker = MapsMarkersManager.lastOpenedMarker;
          let openStatus;
          if (BatchGeoDevices.is("mobile")) {
            openStatus = MobileInfoWindow.open;
          } else {
            openStatus = MapsMarkersManager.openedInfoWindows.find(
              (infoWindow) => infoWindow.id === marker.r,
            )
              ? true
              : false;
          }

          BatchGeoStore.dispatch({
            type: "MAPSMARKERS_MANAGER_MARKER_CLICKED",
            marker: marker,
          });

          BatchGeoStore.getState().MapsMarkersManager.openedInfoWindows.forEach(
            (infoWindow) => {
              if (
                !infoWindow.infoWindow.pinned_ &&
                infoWindow.id !== marker.r
              ) {
                infoWindow.infoWindow.close();
              }
            },
          );

          // If the last opened marker is equal to this marker and
          // the info window is still open we set the center to the
          // marker and zoom in one level
          if (marker === lastOpenedMarker && openStatus) {
            pointToZoom();
          }

          if (BatchGeoStore.getState().App.isMap) {
            // let row select handle marker selection
            const table = window.batchGeoTableMap.batchGeoTable;
            const rowSelect = table.RowSelect;

            // If rows are selected and the marker clicked's corresponding row is a
            // selected row, DON'T deselect all the markers. Only if it's an
            // selected marker.
            if (!rowSelect.isRowSelected(marker.r)) {
              rowSelect.deselectAll();
              rowSelect.select(marker.r, { fromMarkerClick: true });
            } else {
              if (!openStatus) {
                window.batchGeoGoogleMapsMarker.MarkerInfoWindow.open(marker);
              }
            }

            if (!table.isRowVisible(marker.r)) {
              table.scrollToRow(marker.r, {
                position: "middle",
                animated: true,
              });
            }
          } else {
            // map create/edit have no batchgeotable
            if (openStatus) {
              window.batchGeoGoogleMapsMarker.MarkerResizer.zoomIn(marker);
            }
            window.batchGeoGoogleMapsMarker.MarkerInfoWindow.open(marker);
          }
        }

        if (e && e.stop) e.stop();
        return false;
      });

      if (!self.options.markersData.hideaddr_cb) {
        google.maps.event.addListener(marker, "dblclick", function () {
          var coords = marker.position.lat() + "," + marker.position.lng();
          window.open(window.BatchGeoInfoWindowGenerateDirections(coords));
          return false;
        });
      }
    };

    var createMapMarker = function (marker, rowId) {
      var rowMarker = self.options.markersData.mapRS[rowId];
      var options = {
        address: createMarkerAddress(rowId),
        title: rowMarker.t,
        description: createMarkerDescription(rowId),
        descriptionURL: rowMarker.u,
        descriptionIMG: rowMarker.i,
        email: rowMarker.e,
        lat: rowMarker.lt,
        lon: rowMarker.ln,
        id: rowId,
        isSubpremise: rowMarker.isSubpremise,
        dirAddr: rowMarker.dirAddr,
      };

      options.coords = options.lat + "," + options.lon;
      options.address =
        options.address.trim().length === 0 && options.lat
          ? options.coords
          : options.address;

      marker.urlCoords = options.coords;

      marker.textOptions = options;

      bindClickToMarker(marker);

      return marker;
    };

    var createMarkerImage = function (options) {
      if (options.descriptionIMG.indexOf("streetview") >= 0) {
        if (!BatchGeoStore.getState().App.isLite) {
          return (
            '<img class="descIMG lazy streetview" data-src="' +
            options.descriptionIMG +
            '" valign="top" border=0 onclick="BatchGeo.openStreetViewImage(this.alt, \'' +
            encodeURI(options.address.replace("<br />", ",")) +
            '\')" alt="' +
            options.title +
            '">'
          );
        } else {
          return "";
        }
      } else if (options.descriptionIMG && options.descriptionIMG.length > 0) {
        return (
          '<img class="descIMG" src="' +
          options.descriptionIMG +
          '" valign="top" align="center" border=0 vspace=5 hspace=1>'
        );
      }
      return "";
    };

    var createMarkerToolbar = function (options, markerData) {
      var buttons = [];
      var hasURL = options.descriptionURL;
      var hasNav = !markerData.hideaddr_cb;

      // Create zoom button for footer
      buttons.push(
        $("<a />", {
          class: "infowindow-footer-button zoom-button",
          title: "zoom",
          onclick:
            "window.batchGeoGoogleMapsMarker.MarkerContent.pointToZoom()",
        }),
      );

      // Create URL button if marker has URL
      if (hasURL) {
        buttons.push(
          $("<a />", {
            href:
              BatchGeo.leftSubStr(options.descriptionURL.trim(), 3) !== "htt"
                ? "http://" + options.descriptionURL.trim()
                : options.descriptionURL,
            target: !markerData.linkopwin_cb ? "_top" : "_blank",
            rel: "nofollow",
            class: "infowindow-footer-button url-button",
            title: "www",
          }),
        );
      }

      // Create Nav button if address is not hidden
      if (hasNav) {
        buttons.push(
          $("<a />", {
            href: window.BatchGeoInfoWindowGenerateDirections(
              options.address,
              options,
            ),
            class: "infowindow-footer-button nav-button",
            target: "_blank",
            title: "Nav",
            id: "navigation-button",
          }),
        );
      }

      buttons.push(
        $("<a />", {
          id: `${options.id}-pin-button`,
          class: "infowindow-footer-button pin-button",
          title: "pin",
          onclick: `window.batchGeoGoogleMapsMarker.MarkerContent.pinInfoWindow(${options.id})`,
        }),
      );

      return $("<div />", {
        class: buttons.length ? "infowindow-footer" : "no-infowindow-footer",
      }).append(buttons);
    };

    var createMarkerText = function (options, rules = {}) {
      let $markerTitle;
      let $markerImg;
      let $infoWindowFooter;
      let desc = options.description;
      const defaultRules = {
        useImage: true,
        addDirectionsLink: true,
      };

      rules = Object.assign({}, defaultRules, rules);

      desc = desc.replace(
        /([^"|'])((https?|ftp):\/\/[^\\<]+)/gim,
        '$1<a href="$2" target="_blank" rel="nofollow">$2</a>',
      );
      options.address =
        !options.address?.trim() && options.lat
          ? options.coords
          : options.address.trim();

      options.address = BatchGeo.ifstr(options.address);
      options.title = BatchGeo.ifstr(options.title);

      const directionsUrl = window.BatchGeoInfoWindowGenerateDirections(
        BatchGeo.stripHTML(options.address, " "),
        options,
      );

      options.descriptionURL = options.descriptionURL?.trim() ?? "";
      options.address = options.address?.trim() ?? "";
      const unallowedLookup = {
        jp: true,
        kr: true,
        cn: true,
      };
      let goog = "goog";
      if (
        rules.addDirectionsLink && // add directions link toggled
        !options.descriptionURL && // description url is invalid
        options.address && // have a valid address
        !self.options.markersData.hideaddr_cb && // hide address option not toggled
        !BatchGeoDevices.is("mobile") && // not on mobile
        !unallowedLookup[self.options.markersData.locale] // not in an the unallowed locale
      ) {
        goog = "";
      }

      if (!options.address || self.options.markersData.hideaddr_cb) {
        options.addressLink = "";
      } else if (directionsUrl) {
        options.addressLink = `<div class="address"><a href="${directionsUrl}" target="_blank" class="directions-link" title="Open in Google Maps" rel="nofollow" id="markerAddress" data-urladdress="${directionsUrl}">${options.address}</a></div>`;
      } else {
        // dont link to google maps
        options.addressLink = `<div class="address">${options.address}</div>`;
      }
      desc = desc ? options.addressLink + desc : options.addressLink;

      let descURL = "";
      if (options.descriptionURL) {
        options.descriptionURL =
          BatchGeo.leftSubStr(options.descriptionURL, 3) != "htt"
            ? `https://${options.descriptionURL}`
            : options.descriptionURL;

        descURL = `<a href="${options.descriptionURL}" target="${!self.options.markersData.linkopwin_cb ? "_top" : "_blank"}" class="marker ${goog}" rel="nofollow">`;

        if (options.title) {
          $markerTitle = `<h1 class="cardTitle">${descURL + options.title}</a></h1>`;
        } else if (!goog) {
          desc += `<div>${descURL + options.descriptionURL}</a></div>`;
        }
      } else if (options.title) {
        $markerTitle = `<h1 class="cardTitle">${options.title}</h1>`;
      }

      // don't link image if streetview, will already try to open large streetview image
      if (options.descriptionIMG.indexOf("streetview") >= 0) descURL = "";

      // if triggered try to create a marker image if there is one
      if (rules.useImage) {
        const formattedImage = createMarkerImage(options);
        if (formattedImage) {
          $markerImg = descURL + formattedImage + (descURL ? "</a>" : "");
        }
      }

      // if our description doesn't contain email,
      // but the user has selected a value for the email field
      // we attempt to append a mailto: link
      // if the selected email value is invalid, we append as text.
      const descriptionHasEmail = desc.includes("EMAIL");

      if (!descriptionHasEmail && options.email) {
        const foundEmail = BatchGeo.findEmail(options.email);
        desc += foundEmail
          ? `<div><a href=mailto:${foundEmail} target="_blank">${foundEmail}</a></div>`
          : `<div>${options.email.trim()}</div>`;
      }

      const $tooltip = $("<div />", { class: "markerLabel" });
      const $rmMarker = $(
        '<div class="markerLabelExtras"><div class="rmMarker"><a class="icon-remove-circle" aria-hidden="true" data-icon="m" title="remove" onclick="window.batchGeoGoogleMapsMarker.removeMarker()"></a></div></div>',
      );
      const $tooltipContent = $("<div />", { class: "markerContent" });

      if ($markerTitle) $tooltipContent.append($markerTitle);
      desc = desc.trim();
      if (desc) {
        const $tooltipDetails = $(
          `<div class="markerSub"><div class="markerDetails">${desc}</div></div>`,
        );
        if ($markerImg)
          $tooltipDetails.prepend(
            `<div class="markerImage ${$markerTitle ? "" : "no-title"}">${$markerImg}</div>`,
          );
        $tooltipContent.append($tooltipDetails);
      }
      if (!BatchGeoStore.getState().App.isMap) $tooltip.append($rmMarker);
      $tooltip.append($tooltipContent);

      $infoWindowFooter = createMarkerToolbar(
        options,
        self.options.markersData,
      );

      $($tooltip).append($infoWindowFooter);

      desc = desc || $markerTitle ? $($tooltip)[0].outerHTML : "";

      return desc;
    };

    const pinInfoWindow = function (id) {
      const pinButton = document.getElementById(`${id}-pin-button`);
      const existingInfoWindow =
        BatchGeoStore.getState().MapsMarkersManager.openedInfoWindows.find(
          (infoWindow) => infoWindow.id === id,
        );

      if (existingInfoWindow.infoWindow.pinned_) {
        pinButton.classList.add("pin-button");
        pinButton.classList.remove("pin-button-active");
      } else {
        pinButton.classList.add("pin-button-active");
        pinButton.classList.remove("pin-button");
      }

      existingInfoWindow.infoWindow.togglePinned_();
    };

    // Public API
    self.MarkerContent = {
      createMapMarker: createMapMarker,
      createMarkerAddress: createMarkerAddress,
      createMarkerDesc: createMarkerDescription,
      createMarkerText: createMarkerText,
      createMarkerImage: createMarkerImage,
      pointToZoom: pointToZoom,
      pinInfoWindow: pinInfoWindow,
    };
  };

  window.MarkerContent = MarkerContent;
})(window);
